// Catalogue de la boutique (dossier §9). Chiffres de conception, pas des tarifs validés :
// tout fonctionne d'abord en mode test. Un objet n'a qu'un prix de référence par offre.

export interface GemPack {
  id: string;
  name: string;
  /** Prix client final en centimes de CHF (TTC affiché). */
  chf: number;
  gems: number;
}

export const GEM_PACKS: GemPack[] = [
  { id: 'gems_300', name: 'Découverte', chf: 290, gems: 300 },
  { id: 'gems_850', name: 'Standard', chf: 790, gems: 850 },
  { id: 'gems_1700', name: 'Collection', chf: 1490, gems: 1700 },
  { id: 'gems_3600', name: 'Grand pack', chf: 2990, gems: 3600 },
];

export type TokenId = 'tok_x2' | 'tok_x5' | 'tok_restore' | 'tok_reset' | 'tok_salon';

export interface TokenOffer {
  id: string;
  token: TokenId;
  count: number;
  gems: number;
}

/** Jetons vendus en gemmes (prix fixes, toujours disponibles). */
export const TOKEN_OFFERS: TokenOffer[] = [
  { id: 'buy_x2', token: 'tok_x2', count: 1, gems: 15 },
  { id: 'buy_x5', token: 'tok_x5', count: 1, gems: 25 },
  { id: 'buy_restore', token: 'tok_restore', count: 1, gems: 30 },
  { id: 'buy_restore10', token: 'tok_restore', count: 10, gems: 250 },
  { id: 'buy_reset', token: 'tok_reset', count: 1, gems: 20 },
  { id: 'buy_salon', token: 'tok_salon', count: 1, gems: 50 },
];

/** Conversion à sens unique gemmes → pièces, par lots affichés uniquement (jamais l'inverse). */
export const GEM_TO_COIN_LOTS = [
  { id: 'conv_100', gems: 100, coins: 1000 },
  { id: 'conv_500', gems: 500, coins: 5000 },
];

export type CosmeticKind = 'skin' | 'collection' | 'emblem' | 'trail' | 'killfx' | 'deathfx' | 'banner' | 'frame';

export interface Cosmetic {
  id: string;
  kind: CosmeticKind;
  name: string;
  /** Palette appliquée au tank (collections et skins). Couleurs, jamais de changement de hitbox ni de lisibilité. */
  palette?: { hull: number; plate: number; tread: number; barrel: number; band: number; outline: number };
  price: { coins?: number; gems?: number };
  /** Contenu fixe des packs. */
  contains?: string[];
}

/**
 * Cosmétiques originaux. Les cinq styles de base gratuits par classe (Atelier, Désert, Boréal, Obsidienne, Signal)
 * ne sont pas vendus : ils se débloquent en jouant (manifeste des 750 variantes en tranche 8).
 */
export const COSMETICS: Cosmetic[] = [
  { id: 'col:rouille', kind: 'collection', name: 'Rouille douce', price: { coins: 12000 }, palette: { hull: 0xa0603a, plate: 0xc07a4c, tread: 0x3e2a1e, barrel: 0x6e4630, band: 0x8a5a3c, outline: 0x24160e } },
  { id: 'col:menthe', kind: 'collection', name: 'Menthe industrielle', price: { coins: 12000 }, palette: { hull: 0x5fa88a, plate: 0x86c7aa, tread: 0x24433a, barrel: 0x3f7462, band: 0x2f5a4b, outline: 0x10241d } },
  { id: 'col:craie', kind: 'collection', name: 'Craie de chantier', price: { coins: 12000 }, palette: { hull: 0xd6d2c4, plate: 0xece8dc, tread: 0x55524a, barrel: 0x9c978a, band: 0x7a766b, outline: 0x2b2a26 } },
  { id: 'skin:graphite', kind: 'skin', name: 'Graphite poli', price: { coins: 3000 }, palette: { hull: 0x55606b, plate: 0x6f7b87, tread: 0x22272d, barrel: 0x3a424b, band: 0x8e99a5, outline: 0x111418 } },
  { id: 'skin:laiton', kind: 'skin', name: 'Laiton', price: { coins: 4500 }, palette: { hull: 0xb8963e, plate: 0xd4b25c, tread: 0x4a3c18, barrel: 0x8a6e28, band: 0x6e561e, outline: 0x261d08 } },
  { id: 'skin:nuit', kind: 'skin', name: 'Nuit polaire', price: { coins: 6000 }, palette: { hull: 0x2b3a55, plate: 0x3d5175, tread: 0x141c2a, barrel: 0x243049, band: 0x5d7bb0, outline: 0x080c14 } },
  { id: 'emblem:boulon', kind: 'emblem', name: 'Emblème Boulon', price: { coins: 1500 } },
  { id: 'trail:etincelles', kind: 'trail', name: 'Traînée Étincelles', price: { coins: 2500 } },
  { id: 'killfx:vapeur', kind: 'killfx', name: 'Effet Vapeur', price: { coins: 3500 } },
  { id: 'premium:cobalt', kind: 'skin', name: 'Cobalt anodisé', price: { gems: 150 }, palette: { hull: 0x2f6fd6, plate: 0x5b92ea, tread: 0x15315c, barrel: 0x22508f, band: 0x9cc1ff, outline: 0x0a1630 } },
  { id: 'premium:magma', kind: 'skin', name: 'Magma refroidi', price: { gems: 250 }, palette: { hull: 0x3a2622, plate: 0x5a3328, tread: 0x1a100d, barrel: 0x2a1a16, band: 0xff6a2a, outline: 0x0e0806 } },
  { id: 'premium:nacre', kind: 'skin', name: 'Nacre', price: { gems: 350 }, palette: { hull: 0xe6e1ef, plate: 0xf6f2ff, tread: 0x6c6878, barrel: 0xb4aec4, band: 0x9ad6d2, outline: 0x2c2934 } },
  { id: 'pcol:circuit', kind: 'collection', name: 'Collection Circuit imprimé', price: { gems: 600 }, palette: { hull: 0x1f5a3a, plate: 0x2e7d52, tread: 0x0e2a1b, barrel: 0x174a2f, band: 0xe0b030, outline: 0x06140c } },
  { id: 'pcol:aurore', kind: 'collection', name: 'Collection Aurore', price: { gems: 1000 }, palette: { hull: 0x6b4fa8, plate: 0x8b6fd0, tread: 0x2a1e44, barrel: 0x4e3a7c, band: 0x6ff0c8, outline: 0x120c20 } },
  {
    id: 'pack:fondateur',
    kind: 'collection',
    name: 'Pack fondateur',
    price: { gems: 1200 },
    contains: ['pcol:circuit', 'premium:cobalt', 'emblem:boulon', 'trail:etincelles'],
    palette: { hull: 0x1f5a3a, plate: 0x2e7d52, tread: 0x0e2a1b, barrel: 0x174a2f, band: 0xe0b030, outline: 0x06140c },
  },
];

export const COSMETIC_BY_ID = new Map(COSMETICS.map((c) => [c.id, c]));

/** Valeur d'un cosmétique en gemmes (les prix en pièces sont convertis au taux des lots : 1 gemme = 10 pièces). */
export function gemValue(c: Cosmetic): number {
  return c.price.gems ?? Math.ceil((c.price.coins ?? 0) / 10);
}

/**
 * Prix réel d'un cosmétique pour un joueur. Un pack coûte son prix moins la valeur de ce qu'il possède déjà, et
 * n'est plus vendu s'il possède tout son contenu (choix de Léni, 4 novembre 2026) : null.
 */
export function effectivePrice(c: Cosmetic, owned: ReadonlySet<string>): Cosmetic['price'] | null {
  if (!c.contains) return c.price;
  const items = c.contains.map((id) => COSMETIC_BY_ID.get(id)).filter((x): x is Cosmetic => !!x);
  const have = items.filter((x) => owned.has(x.id));
  if (have.length === items.length) return null;
  // Jamais 0 : un débit nul ne serait pas écrit et l'achat passerait pour un rejeu, sans rien donner.
  return { gems: Math.max(1, (c.price.gems ?? 0) - have.reduce((sum, x) => sum + gemValue(x), 0)) };
}

/** Rotation hebdomadaire (lundi 00:00 UTC) : 6 offres en pièces, 4 en gemmes, 1 pack thématique. Prix fixes, sans fausse remise. */
export function weeklyShop(weekKey: string): { coins: string[]; gems: string[]; pack: string } {
  let h = 2166136261;
  for (let i = 0; i < weekKey.length; i++) {
    h ^= weekKey.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const rand = () => {
    h = (h + 0x6d2b79f5) >>> 0;
    let t = h;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  const shuffle = <T>(a: T[]) => {
    const l = [...a];
    for (let i = l.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [l[i], l[j]] = [l[j], l[i]];
    }
    return l;
  };
  const coinItems = COSMETICS.filter((c) => c.price.coins && !c.contains).map((c) => c.id);
  const gemItems = COSMETICS.filter((c) => c.price.gems && !c.contains).map((c) => c.id);
  return { coins: shuffle(coinItems).slice(0, 6), gems: shuffle(gemItems).slice(0, 4), pack: 'pack:fondateur' };
}

/** Boosts (§6) : durées et règles d'usage. */
export const BOOSTS = {
  tok_x2: { mul: 2, seconds: 90, scope: 'all' as const },
  tok_x5: { mul: 5, seconds: 60, scope: 'kills' as const },
  maxPerLife: 2,
  maxWallSeconds: 600,
};
export const MAX_RESTORES_PER_CHAIN = 2;
export const RESET_COOLDOWN_S = 15 * 60;
